var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFunnel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11923_27419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 22.4425V10.8508C15.5 10.6237 15.5773 10.4034 15.7191 10.2261L22.2002 2.1247C22.7241 1.46993 22.2579 0.5 21.4194 0.5H2.16244C1.31003 0.5 0.84844 1.49816 1.4005 2.14765L8.26194 10.2199C8.41562 10.4007 8.5 10.6303 8.5 10.8676V18.514C8.5 18.8208 8.64089 19.1107 8.88218 19.3003L13.8822 23.2289C14.5383 23.7444 15.5 23.277 15.5 22.4425Z",
    fill: "#313131"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11923_27419"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnel);
export default __webpack_public_path__ + "static/media/Funnel.a90edbf786c2aa4b16539aa29160b044.svg";
export { ForwardRef as ReactComponent };